import React, { FC } from 'react'
import styled from 'styled-components'

import AngleRightIcon from '@Assets/SVG/AngleRight'
import { CategoryIcon, SVGIcon } from '@Components/Icons'
import { SidePane } from '@Components/SidePane'
import { Category } from '@Generated/graphql'
import { box, flexCenterChildren } from '@Globals/Style/mixins'
import { useTranslation } from '@Globals/Translations'

import { SubCategoryItem } from './SubCategoryItem'

interface SubCategoryMenuProps {
  category: Category
  isShowing: boolean
  onCloseClick: () => void
}

const StyledMenuHeader = styled.div`
  display: flex;
  align-items: center;
  height: 70px;
  background-color: ${({ theme }) => theme.colors.greyLightest};
  border-bottom: 1px solid ${({ theme }) => theme.colors.greyLighter};
`

const StyledBackIcon = styled.div`
  ${box({ height: '70px', width: '54px' })}
  padding: 27px 19px;
  ${flexCenterChildren};
  transform: rotateZ(180deg);
`

const StyledTitleWrap = styled.div`
  display: flex;
  align-items: center;
`

const StyledTitleIcon = styled.div`
  margin-right: 10px;
`

export const SubCategoryMenu: FC<SubCategoryMenuProps> = (
  {
    category,
    isShowing,
    onCloseClick,
  }: SubCategoryMenuProps,
) => {
  const { t } = useTranslation()

  return (
    <SidePane isShowing={isShowing} onClose={onCloseClick} useBackdrop={false}>
      <StyledMenuHeader>
        <StyledBackIcon onClick={onCloseClick}>
          <SVGIcon icon={AngleRightIcon} size="16px" />
        </StyledBackIcon>
        <StyledTitleWrap>
          <StyledTitleIcon>
            <CategoryIcon categoryID={category.id} />
          </StyledTitleIcon>
          <span>{category.name}</span>
        </StyledTitleWrap>
      </StyledMenuHeader>

      {/* Body */}
      <div>
        {/* View all link */}
        <SubCategoryItem
          categoryID={category.id}
          title={t('header:HEADER_MOBILE_MENU_VIEW_ALL_LABEL')}
          url={category.url || ''}
        />

        {/* Rest of sub categories */}
        {category.children?.map(child => (
          <SubCategoryItem
            key={child.id}
            categoryID={child.id}
            title={child.name || ''}
            url={child.url || ''}
          />
        ))}
      </div>

    </SidePane>
  )
}
